// extracted by mini-css-extract-plugin
module.exports = {"styles":"ehm_2QfqkZqD5xx43UYp1"};